import React from 'react';
import PropTypes from 'prop-types';

import { SceneAnimationContext } from '../scenes/Scene';

export const AnimationOnPageLoadContext = React.createContext({});

class AnimationOnPageLoadGroup extends React.PureComponent {
  static propTypes = {
    shouldRunAnimation: PropTypes.bool.isRequired,
  };

  nodes = [];

  registerNode = node => this.nodes.push(node);

  state = {
    context: {
      registerNode: this.registerNode,
    },
  };

  componentDidMount() {
    if (this.props.shouldRunAnimation) {
      this.runAnimation();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shouldRunAnimation !== this.props.shouldRunAnimation && this.props.shouldRunAnimation) {
      this.runAnimation();
    }
  }

  runAnimation() {
    TweenMax.staggerFromTo(
      this.nodes,
      0.45,
      { y: 100, alpha: 0 },
      { y: 0, alpha: 1, ease: Power1.easeOut, clearProps: 'transform', delay: 0.1 },
      0.1
    );
  }

  render() {
    return (
      <AnimationOnPageLoadContext.Provider value={this.state.context}>
        {this.props.children}
      </AnimationOnPageLoadContext.Provider>
    );
  }
}

const AnimationOnPageLoadGroupConnected = props => (
  <SceneAnimationContext.Consumer>
    {({ shouldRunContentAnimation }) => (
      <AnimationOnPageLoadGroup shouldRunAnimation={shouldRunContentAnimation} {...props} />
    )}
  </SceneAnimationContext.Consumer>
);

export default AnimationOnPageLoadGroupConnected;



// WEBPACK FOOTER //
// ./src/components/AnimationOnPageLoadGroup.js